import type { HeadlinePriceType } from '@phx/data-sources/medication-marketplace';

export const isIncentiveOffer = (
    offer?:
        | { headlinePriceType?: HeadlinePriceType | string | null }
        | undefined
): boolean => isIncentivePrice(offer?.headlinePriceType);

export const isIncentivePrice = (
    headlinePriceType?: HeadlinePriceType | string | null
): boolean =>
    headlinePriceType === 'PharmacyIncentive' ||
    headlinePriceType === 'Incentive';
